module.exports = __webpack_public_path__ + "img/hive-engine.74638d6b.png";